var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[(_vm.headerState)?_c('header-menu',{attrs:{"logo":_vm.logoUrl}}):_vm._e(),_c('router-view'),(_vm.mLoginModal.show)?_c('Login'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }